export { default } from "/jsonhero/app/routes/index.tsx";